import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Projections",
description: "Learn how to define projections in Freon, including property inclusion, named projections, lists, tables, optional projections, and inherited projections for flexible and readable editor layouts.",
tags: [ "projections", "editor definition", "named projections", "lists", "tables", "optional projections", "inherited projections", "Freon", "DSL development", "concrete syntax"] ,
modifiedTime: "2025-11-07T19:03:58.393Z",
publishedTime: "2025-11-07T17:20:18.610Z"
    }
  };
};